import React from "react";
import "./Badge.css";

function Badge({ count }) {
  if (!count || count <= 0) return null;

  return <div className="badge">{count > 99 ? "99+" : count}</div>;
}

export default Badge;
